import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import './Home.css';

import NewsletterModal from "../components/NewsletterModal";
import FooterAction from '../components/FooterAction';

/* Replace this URL with your actual hero image after uploading */
const HERO_IMAGE = 'https://imagedelivery.net/S_KBi515leX4rwPDIF-mpg/1b89f4f2-feab-4ff4-2876-88f15f576b00/f=auto,fit=cover';
const ALBUM_ART  = 'https://imagedelivery.net/S_KBi515leX4rwPDIF-mpg/d70b3f8f-d839-43f0-b0d1-a901f95a1400/public';
const MERCH_URL  = 'https://2gcollective.creator-spring.com';

// const socials = [
//   { label: 'Spotify',     url: 'https://open.spotify.com/artist/69CmS1z7XlPgstN0L95gdK',     Icon: SpotifyIcon },
//   { label: 'Apple Music', url: 'https://music.apple.com/artist/2gs-like-gucci/1497262163',    Icon: AppleIcon },
//   { label: 'Instagram',   url: 'https://www.instagram.com/2gs_likegucci93',                   Icon: InstagramIcon },
//   { label: 'YouTube',     url: 'https://youtube.com/@2gslikegucci',                           Icon: YouTubeIcon },
//   { label: 'Bandcamp',    url: 'https://beatedge.bandcamp.com',                               Icon: BandcampIcon },
// ];

export default function Home() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) setSubscribed(true);
  };

  const [showNewsletter, setShowNewsletter] =
  useState(false);


  return (
    <div className="home">

      {showNewsletter && (
        <NewsletterModal
          onClose={() =>
            setShowNewsletter(false)
          }
        />
      )}
      <Navbar />

      {/* Hero */}
      <section className="hero">
        {/* <img src={HERO_IMAGE} alt="2gs Like Gucci" className="hero-img" /> */}
        <img src="/images/heroimg.png" alt="2gs Like Gucci" className="hero-img" />
        <div className="hero-overlay" />

        <div className="hero-content">
         
          {/* <a href={MERCH_URL} target="_blank" rel="noopener noreferrer" className="merch-card">
            
            <img src="/images/heroimg.png" alt="2G Collective album art" className="merch-thumb" />
            <div className="merch-info">
              <p className="merch-title">2G Collective: The Double Up Collection</p>
              <span className="merch-link">View →</span>
            </div>
          </a> */}

          {/* Merch Card */}
          <a href={MERCH_URL} target="_blank" rel="noopener noreferrer" className="merch-card">
            <div className="merch-card-blur" style={{backgroundImage: `url(/images/albumart.png)`}} />
            <img src="/images/heroimg.png" alt="2G Collective album art" className="merch-thumb" />
            <div className="merch-info">
              <p className="merch-title">2G Collective: The Double Up Collection</p>
              <span className="merch-link">View →</span>
            </div>
          </a>

          <FooterAction />
        </div>
      </section>
    </div>
  );
}















// import React, { useState } from 'react';
// import Navbar from '../components/Navbar';
// import './Home.css';

// import NewsletterModal from "../components/NewsletterModal";

// /* Replace this URL with your actual hero image after uploading */
// const HERO_IMAGE = 'https://imagedelivery.net/S_KBi515leX4rwPDIF-mpg/1b89f4f2-feab-4ff4-2876-88f15f576b00/f=auto,fit=cover';
// const ALBUM_ART  = 'https://imagedelivery.net/S_KBi515leX4rwPDIF-mpg/d70b3f8f-d839-43f0-b0d1-a901f95a1400/public';
// const MERCH_URL  = 'https://2gcollective.creator-spring.com';

// const socials = [
//   { label: 'Spotify',     url: 'https://open.spotify.com/artist/69CmS1z7XlPgstN0L95gdK',     Icon: SpotifyIcon },
//   { label: 'Apple Music', url: 'https://music.apple.com/artist/2gs-like-gucci/1497262163',    Icon: AppleIcon },
//   { label: 'Instagram',   url: 'https://www.instagram.com/2gs_likegucci93',                   Icon: InstagramIcon },
//   { label: 'YouTube',     url: 'https://youtube.com/@2gslikegucci',                           Icon: YouTubeIcon },
//   { label: 'Bandcamp',    url: 'https://beatedge.bandcamp.com',                               Icon: BandcampIcon },
// ];

// export default function Home() {
//   const [email, setEmail] = useState('');
//   const [subscribed, setSubscribed] = useState(false);

//   const handleSubscribe = (e) => {
//     e.preventDefault();
//     if (email) setSubscribed(true);
//   };

//   const [showNewsletter, setShowNewsletter] =
//   useState(false);


//   return (
//     <div className="home">

//       {showNewsletter && (
//         <NewsletterModal
//           onClose={() =>
//             setShowNewsletter(false)
//           }
//         />
//       )}
//       <Navbar />

//       {/* Hero */}
//       <section className="hero">
//         {/* <img src={HERO_IMAGE} alt="2gs Like Gucci" className="hero-img" /> */}
//         <img src="/images/heroimg.png" alt="2gs Like Gucci" className="hero-img" />
//         <div className="hero-overlay" />

//         <div className="hero-content">
         
//           {/* <a href={MERCH_URL} target="_blank" rel="noopener noreferrer" className="merch-card">
            
//             <img src="/images/heroimg.png" alt="2G Collective album art" className="merch-thumb" />
//             <div className="merch-info">
//               <p className="merch-title">2G Collective: The Double Up Collection</p>
//               <span className="merch-link">View →</span>
//             </div>
//           </a> */}

//           {/* Merch Card */}
//           <a href={MERCH_URL} target="_blank" rel="noopener noreferrer" className="merch-card">
//             <div className="merch-card-blur" style={{backgroundImage: `url(/images/albumart.png)`}} />
//             <img src="/images/heroimg.png" alt="2G Collective album art" className="merch-thumb" />
//             <div className="merch-info">
//               <p className="merch-title">2G Collective: The Double Up Collection</p>
//               <span className="merch-link">View →</span>
//             </div>
//           </a>

//           {/* Subscribe */}
//           {!subscribed ? (
//             <form className="subscribe-form" onSubmit={handleSubscribe}>
//               <button type="button" className="subscribe-btn"
//                onClick={() => setShowNewsletter(true)}
//               >
//                 <MailIcon /> Subscribe for updates
//               </button>
//             </form>
//           ) : (
//             <p className="subscribe-thanks">✓ Thanks for subscribing!</p>
//           )}

//           {/* Social Icons */}
//           <div className="social-row">
//             {socials.map((s) => (
//               <a
//                 key={s.label}
//                 href={s.url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="social-icon-btn"
//                 aria-label={s.label}
//                 title={s.label}
//               >
//                 <s.Icon />
//               </a>
//             ))}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// /* ── Icons ── */
// function MailIcon() {
//   return (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
//       <rect x="2" y="4" width="20" height="16" rx="2"/>
//       <polyline points="2,4 12,13 22,4"/>
//     </svg>
//   );
// }

// function SpotifyIcon() {
//   return (
//     <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
//       <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
//     </svg>
//   );
// }

// function AppleIcon() {
//   return (
//     <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
//       <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
//     </svg>
//   );
// }

// function InstagramIcon() {
//   return (
//     <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
//       <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
//     </svg>
//   );
// }

// function YouTubeIcon() {
//   return (
//     <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
//       <path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/>
//     </svg>
//   );
// }

// function BandcampIcon() {
//   return (
//     <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
//       <path d="M0 18.75l7.437-13.5H24l-7.438 13.5z"/>
//     </svg>
//   );
// }
